import { Row, Col, Card, Space, Typography } from 'antd';
import {
  convertCentsIntoDollar,
  formatDate,
} from '../../../helpers/genericHelper';
import CustomText from '../../CustomText';
import Data from '../../CustomText/data';

const { Title } = Typography;

function SBPaymentHistoryComponent({ payments = [] }) {
  const pillColor = (status) => {
    switch (status) {
      case 'SUCCESS':
        return 'success';
      case 'OVERDUE':
        return 'error';
      default:
        return 'processing';
    }
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      {payments && payments.length > 0 ? (
        payments.map((data) => {
          return (
            <Card
              bordered={true}
              hoverable={true}
            >
              <Row>
                <Col span="4">
                  <Data title="Date">
                    {formatDate(data?.createTs, true)}
                  </Data>
                </Col>

                <Col span="3">
                  <Data title="Amount">
                    {convertCentsIntoDollar(data?.amount)}
                  </Data>
                </Col>

                <Col span="3">
                  <Data title="Payment Due Date">
                    {formatDate(data?.paymentDueDate)}
                  </Data>
                </Col>

                <Col span="4">
                  <Data title="Payment Success Time">
                    {formatDate(data?.paymentSuccessInstant, true)}
                    </Data>
                </Col>
                <Col span="1"></Col>
                <Col span="4">
                  <Space direction='vertical'>
                    <Data isTag tagColor={pillColor(data?.paymentStatus)} title="Status" value={data?.paymentStatus}/>
                    <Data isTag tagColor="processing" title="Payment Pull Attempts" value={data?.paymentPullAttempts}/>
                    { data?.lastPayment && <Data isTag tagColor="success" title="Last Payment" value={data?.lastPayment ? "YES" : "NO"}/> }
                    <Data isTag tagColor="processing" title="Manual Payment" value={data?.manualPayment ? "YES" : "NO"}/>
                  </Space>
                </Col>
                <Col span="4">
                  <Space direction='vertical'>
                    <Data isTag tagColor="processing" title="Retry Count" value={data?.retryCount}/>
                    { data?.paymentFailedReason !== "NONE" && <Data isTag tagColor="processing" title="Payment failure reason" value={data?.paymentFailedReason}/>  }
                    <Data isTag tagColor="processing" title="Payment Mode" value={data?.paymentMode}/>
                  </Space>
                </Col>
              </Row>
            </Card>
          );
        })
      ) : (
        <Row>No Payments Found</Row>
      )}
    </Space>
  );
}

export default SBPaymentHistoryComponent;
